// React importado primeiro para evitar múltiplas instâncias (Invalid hook call)
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import CssBaseline from '@material-ui/core/CssBaseline';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary';
import moment from 'moment';
import 'moment/locale/pt-br';
moment.locale('pt-br');

// Filtro para esconder apenas alguns warnings chatos de libs (sem afetar o resto)
const originalConsoleError = console.error;
console.error = (...args) => {
  const messages = args.filter((a) => typeof a === 'string').join(' ');

  // ToastContainer2 / defaultProps deprecado
  if (messages.includes('defaultProps will be removed from function components')) return;

  // findDOMNode deprecado no React StrictMode / Material-UI
  if (messages.includes('findDOMNode is deprecated and will be removed in the next major release'))
    return;

  originalConsoleError(...args);
};

// PWA: register service worker (do not unregister on every load so updates can be detected)
/* global __BUILD_TIME__ */
const BUILD_TIME = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : 0;
const PWA_UPDATE_EVENT = 'pwa-update-available';
const PWA_SW_WAITING_EVENT = 'pwa-sw-waiting';

function checkForNewVersion() {
  if (BUILD_TIME === 0) return; // dev
  const url = `${window.location.origin}/version.json?t=${Date.now()}`;
  fetch(url, { cache: 'no-store' })
    .then((res) => res.json())
    .then((data) => {
      if (data && typeof data.buildTime === 'number' && data.buildTime > BUILD_TIME) {
        window.dispatchEvent(new CustomEvent(PWA_UPDATE_EVENT, { detail: data }));
      }
    })
    .catch(() => {});
}

function applyPwaUpdate() {
  const unregisterAndReload = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        Promise.all(regs.map((r) => r.unregister())).then(() => {
          if ('caches' in window) {
            caches
              .keys()
              .then((names) => Promise.all(names.map((n) => caches.delete(n))))
              .then(() => {
                window.location.reload();
              });
            return;
          }
          window.location.reload();
        });
      });
      return;
    }
    window.location.reload();
  };
  if ('caches' in window) {
    caches
      .keys()
      .then((names) => Promise.all(names.map((n) => caches.delete(n))))
      .then(unregisterAndReload);
  } else {
    unregisterAndReload();
  }
}

window.applyPwaUpdate = applyPwaUpdate;

if ('serviceWorker' in navigator && window.isSecureContext) {
  const swUrl = `${process.env.PUBLIC_URL || ''}/sw-push.js`;
  navigator.serviceWorker
    .register(swUrl, { scope: '/' })
    .then((registration) => {
      window.__swRegistration__ = registration;
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            window.dispatchEvent(new CustomEvent(PWA_SW_WAITING_EVENT));
          }
        });
      });
      setInterval(() => registration.update(), 60 * 60 * 1000);
    })
    .catch(() => {});

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    window.location.reload();
  });
}

checkForNewVersion();
if (typeof document !== 'undefined' && document.addEventListener) {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') checkForNewVersion();
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  React.createElement(
    ErrorBoundary,
    null,
    React.createElement(CssBaseline, null, React.createElement(App))
  )
);
